/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SlidingComponentLinkTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ComponentCard from "./ComponentCard";
import LegalRequirementTemplate from "./LegalRequirementTemplate";
import TestCaseTemplate from "./TestCaseTemplate";
import { componentStyle } from "../../../config/appTheme";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function SlidingComponentLinkTemplate({
  headerTitle = "",
  dataList = [],
  handleSelectedComponent,
  selectedComponentDetails,
  linkedLegalRequirement,
  renderCardActionIcons,
  page,
  rowsPerPage,
  handlePageChange,
  totalCount,
  componentType,
  searchKeys,
  unlinkLegalRequirement,
  cardOpen,
  setCardOpen,
  contentHeight = null,
}) {
  const [showLegalCheckBox, setShowLegalCheckBox] = useState(false);
  const [showLinkedTestCase, setShowLinkedTestCase] = useState(false);

  useEffect(() => {
    setShowLegalCheckBox(
      [1, 2].includes(Number(selectedComponentDetails?.data?.action_type)),
    );
  }, [selectedComponentDetails]);

  const transitionStyle = {
    transition: "width 0.4s ease-in-out, height 0.4s ease-in-out",

    display: "flex",
    flexDirection: "column",
  };

  const closedHeight = "3rem";
  const openHeight = "30rem";

  return (
    <Box
    // sx={{ display: "flex", gap: 0.5 }}
    >
      <Grid container>
        <Grid
          item
          sm={5}
          sx={{
            ...transitionStyle,
            height: cardOpen ? openHeight : closedHeight,
            minWidth: cardOpen ? "auto" : "0px",
          }}
        >
          {!cardOpen && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                alignItems: "center",
                backgroundColor: "#000000",
                color: "#ffffff",
              }}
            >
              <Typography sx={{ ...componentStyle.font.cardHeadder }}>
                {selectedComponentDetails?.data?.description}
              </Typography>
              <Box
                onClick={() => {
                  setCardOpen(true);
                }}
                sx={{ cursor: "pointer" }}
              >
                <KeyboardArrowDownIcon />
              </Box>
            </Box>
          )}

          <Box
            sx={{
              flexGrow: 1,
              opacity: cardOpen ? 1 : 0, // Fade content out/in
              transition: "opacity 0.3s ease-in-out 0.1s",
            }}
          >
            <ComponentCard
              headerTitle={headerTitle}
              dataList={dataList}
              handleSelectedComponent={handleSelectedComponent}
              selectedComponentDetails={selectedComponentDetails}
              renderCardActionIcons={renderCardActionIcons}
              page={page}
              rowsPerPage={rowsPerPage}
              handlePageChange={handlePageChange}
              totalCount={totalCount}
              contentHeight={contentHeight}
            />
          </Box>
        </Grid>

        {cardOpen && (
          <Grid
            sm={0.2}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: -1,
              pt: -1,
            }}
          >
            <Divider
              sx={{
                border: cardOpen ? "1px solid #6B7280" : "none",
                height: "26rem",
                ml: 0.5,

                width: "1px",
              }}
            />
          </Grid>
        )}

        <Grid
          item
          sm={cardOpen ? 6.8 : 12}
          sx={{
            ...transitionStyle,
            height: openHeight,
            position: "relative",
          }}
        >
          {/* Area for table */}
          <Box
            sx={{
              height: "100%",
              padding: "10px",
            }}
          >
            {!showLinkedTestCase ? (
              <LegalRequirementTemplate
                selectedComponentDetails={selectedComponentDetails}
                linkedLegalRequirement={linkedLegalRequirement}
                componentType={componentType}
                searchKeys={searchKeys}
                showCheckBox={showLegalCheckBox}
                setShowLinkedTestCase={setShowLinkedTestCase}
                unlinkLegalRequirement={unlinkLegalRequirement}
              />
            ) : (
              <TestCaseTemplate />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SlidingComponentLinkTemplate;
